import { FlowV2_Action__Input } from '~/graphql/types';
import { ClientFlowActionStopFlows } from '~/graphql/types.client';

/**
 *
 * @param {ClientFlowActionStopFlows} action - StopFlows client action
 */
const serializeStopFlowsAction = (
  action: ClientFlowActionStopFlows,
): FlowV2_Action__Input => {
  const { id, accountId, flowBlueprintId, parentIds, toStopFlowBlueprintIds } =
    action;

  return {
    StopFlows: {
      id,
      accountId,
      flowBlueprintId,
      parentIds,
      toStopFlowBlueprintIds,
    },
  };
};
export default serializeStopFlowsAction;
